export const validatorsFiltersTradeAgreementOrder = {
  year: 'year',
  regionId: 'regionId',
  lineId: 'lineId',
  clientId: 'clientId',
  subRegionId: 'subRegionId',
  territoryId: 'territoryId',
};
